<template>
  <div>
    <ContentLoader
      :height="57"
      :width="220"
      :speed="1"
      primary-color="#f3f3f3"
      secondary-color="#ecebeb"
      class="price-card-loader"
    >
      <rect x="30" y="6" rx="4" ry="4" width="160" height="30" />
      <rect x="0" y="43" rx="3" ry="3" width="220" height="13" />
    </ContentLoader>
  </div>
</template>

<style lang="scss" scoped>
.price-card-loader {
  max-width: 220px;
}
</style>

<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: {
    ContentLoader,
  },
};
</script>
